import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { clearStore, setStore } from '@/models/store';
import { useStores } from '@/hooks/useStores';
import { getNextPath } from './storeNavigation';
import { $user, setAllowAnotherStore } from '@/models/user';
import { GroupsEnum } from '@/types/users';
import { hasAnyGroup } from '@/utils/groups';
import { Button } from '@/components/ui/Button';

const StoreSelectionPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUnit($user);
  const { stores, loading, error } = useStores();
  const nextPath = getNextPath(location.search);
  const hasClientRole = hasAnyGroup(user?.groups, [GroupsEnum.CLIENT]);

  useEffect(() => {
    if (!loading && stores.length === 1) {
      setStore(stores[0]);
      navigate(nextPath, { replace: true });
    }
  }, [loading, navigate, nextPath, stores]);

  if (loading || stores.length === 1) {
    return (
      <div className="flex min-h-[320px] items-center justify-center text-gray-500">
        Загрузка магазинов...
      </div>
    );
  }

  return (
    <section className="mx-auto w-full max-w-3xl py-8 md:py-12">
      <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm md:p-8">
        <h2 className="text-center text-2xl font-semibold text-gray-900">Выберите секцию</h2>

        {!error && stores.length === 0 && (
          <div className="mt-6 rounded-lg bg-gray-50 px-4 py-6 text-center text-gray-600">
            Для пользователя не найдено доступных магазинов.
          </div>
        )}

        <div className="mt-8 flex flex-col gap-4">
          {stores.map((store) => (
            <Button
              key={store.id}
              type="button"
              fullWidth
              size="lg"
              className="shadow-sm"
              onClick={() =>
                navigate(
                  `/section/confirm/${encodeURIComponent(store.id)}?next=${encodeURIComponent(nextPath)}`,
                )
              }
            >
              {store.number} {store.title}
            </Button>
          ))}
          {hasClientRole && (
            <Button
              type="button"
              variant="secondary"
              fullWidth
              size="lg"
              className="shadow-sm"
              onClick={() => {
                clearStore();
                setAllowAnotherStore(true);
                navigate('/', { replace: true });
              }}
            >
              Другой магазин (подработка)
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default StoreSelectionPage;
